(function () {
    'use strict';

    angular
        .module('app.ics')
        .controller('IcsController', Ics);


    Ics.$inject = ['$scope', 'IcsSettings'];

    function Ics($scope, IcsSettings) {
        var vm = this;

        vm.settingsExist = false;

        if (window.location.pathname.match(/^\/ics\/?$/i)) {
            IcsSettings.get({id: window.ICS_CONFIG.accountId}, function (data) {
                if (data.hasSettings === false) {
                    window.location.assign("/ics/branding");
                } else {
                    vm.settingsExist = true;
                }
            });
        }


         function getAuthToken(){
            $.ajax({
                type: "GET",
                url: "/ics/auth",
                success: function(data){
                    if (window.ICS_CONFIG){
                        window.ICS_CONFIG.token = data;
                    }
                }
            });
        }

        setInterval(getAuthToken, 5 * 60 * 1000); // 10 minutes
    }
})();
